import { render, staticRenderFns } from "./ButtonCustomIcon.vue?vue&type=template&id=177f2e7e&scoped=true"
import script from "./ButtonCustomIcon.vue?vue&type=script&lang=js"
export * from "./ButtonCustomIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f2e7e",
  null
  
)

export default component.exports